export enum ELocalStorageKeys {
  CONFIGURATION_CLIENT_TIMEZOME = "@hospitality/configuration/timezone",
  SIDE_MENU_COLLAPSE_LOCAL_STORAGE_KEY = "@hospitality/settings/sidemenu/collapsed",
  LANGUAGE_LOCALE_STORAGE_KEY = "@hospitality/settings/locale",
}
